
<template>
  <Nav-bar :has_back="true" :has_right="false" title="发票抬头信息"></Nav-bar>
  <div class="top-margin"></div>
  <div class="container m-t-10">
    <div class="t-f14-c1a m-15">发票信息</div>
    <div class="display_flex item-container m-t-10">
      <span class="t-f14-c66">抬头类型</span>
      <div class="m-l-32">
        <van-radio-group v-model="checked" direction="horizontal" >
          <van-radio name="1" icon-size="15px">个人</van-radio>
          <van-radio name="2" icon-size="15px">企业</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="display_flex item-container" style="border-top: 1px #eee solid">
      <div class="display_flex">
        <span class="t-f14-c66">发票类型</span>
        <img
          src="@/images/charging_package_question.png"
          class="question"
          @click="showOverlay = true"
        />
      </div>
      <div class="m-l-15">
        <van-radio-group
          v-model="invoiceType"
          direction="horizontal"
          @change="invoiceTypeLisen"
        >
          <van-radio name="0" icon-size="15px">普通发票</van-radio>
          <van-radio name="1" icon-size="15px" :disabled="checked == 1"
            >专用发票</van-radio
          >
        </van-radio-group>
      </div>
    </div>
    <div class="display_flex item-container m-t-10">
      <span class="t-f14-c66">发票抬头</span>
      <div style="margin-left: 30px">
        <van-field
          v-model="titleValue"
          placeholder="请填写抬头"
          :error="titleValue == '' && isError"
        />
      </div>
    </div>
    <div class="display_flex item-container line" v-if="checked == 2">
      <span class="t-f14-c66">纳税人识别号</span>
      <div class="m-l-5">
        <van-field
          v-model="companyCode"
          placeholder="请输入纳税人识别码"
          :error="companyCode == '' && isError"
        />
      </div>
    </div>
    <div class="display_flex item-container line" v-if="checked == 2">
      <span class="t-f14-c66">基本开户银行</span>
      <div class="m-l-5">
        <van-field
          v-model="bankName"
          placeholder="请填写开户银行"
          :error="bankName == '' && isError && invoiceType == 1"
        />
      </div>
    </div>
    <div class="display_flex item-container line" v-if="checked == 2">
      <span class="t-f14-c66">基本开户账号</span>
      <div class="m-l-5">
        <van-field
          v-model="bankAccountNumber"
          placeholder="请填写开户账号"
          :error="bankAccountNumber == '' && isError && invoiceType == 1"
        />
      </div>
    </div>
    <div class="display_flex item-container line" v-if="checked == 2">
      <span class="t-f14-c66">企业注册地址</span>
      <div class="m-l-5">
        <van-field
          v-model="registrationAddress"
          placeholder="请填写企业注册地址"
          :error="registrationAddress == '' && isError && invoiceType == 1"
        />
      </div>
    </div>
    <div class="display_flex item-container line" v-if="checked == 2">
      <span class="t-f14-c66">企业注册电话</span>
      <div class="m-l-5">
        <van-field
          v-model="registrationPhone"
          placeholder="请填写企业注册电话"
          :error="registrationPhone == '' && isError && invoiceType == 1"
        />
      </div>
    </div>
    <div class="m-20" @click="apiPostCreateTitle">
      <van-button type="primary" size="normal" class="main-btn"
        >保存</van-button
      >
    </div>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper">
        <div class="block">
          <img
            src="@/images/charging_package_topup_close.png"
            class="topup-close"
            @click="showOverlay = false"
          />
          <div class="tip-container">
            <span class="t-f16-c1a">企业增值税普通发票</span>
            <span class="t-f14-c66 m-t-10"
              >适用于小规模纳税人，开具的发票不能进行进项税额抵扣。</span
            >
          </div>
          <div class="tip-container">
            <span class="t-f16-c1a">企业增值税专用发票</span>
            <span class="t-f14-c66 m-t-10"
              >适用于一般纳税人，开具的发票可以进行进项税额抵扣。</span
            >
          </div>
          <div class="tip-container">
            <span class="t-f16-c1a">个人增值税普通发票</span>
            <span class="t-f14-c66 m-t-10"
              >适用于小规模纳税人，开具的发票不能进行进项税额抵扣。</span
            >
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { useRouter } from "vue-router";
import { ref } from "vue";
import { Toast } from "vant";
import request from "@/api/request";
let router;
let checked = ref("1"); //单选按钮
let invoiceType = ref("0");
let titleValue = ref(""); //抬头内容
let companyCode = ref(""); //识别号
let bankName = ref(""); //银行名字
let bankAccountNumber = ref(""); //银行账号
let registrationAddress = ref(""); //企业地址
let registrationPhone = ref(""); //企业电话
let isError = ref(false); //是否显示必填提示
let showOverlay = ref(false); //企业发票说明
let paramsId;
export default {
  components: {
    NavBar,
  },
  unmounted() {
    checked.value = "1"; //单选按钮
    invoiceType.value = "0"; //单选按钮
     titleValue.value = ""; //抬头内容
    clearCompanyData();
  },

  setup() {
    router = useRouter();
    paramsId = router.currentRoute.value.params.id;

    if (paramsId != undefined) {
      getInvoiceDetails(paramsId);
    }
    return {
      toRecharge,
      checked,
      invoiceType,
      apiPostCreateTitle,
      invoiceTypeLisen,
      getInvoiceDetails,
      bankName,
      bankAccountNumber,
      registrationAddress,
      registrationPhone,
      titleValue,
      isError,
      showOverlay,
      companyCode,
      clearCompanyData,
    };
  },
};
function clearCompanyData() {
  companyCode.value = ""; //识别号
  bankName.value = "";
  bankAccountNumber.value = "";
  registrationAddress.value = "";
  registrationPhone.value = "";
  isError.value = false;
  showOverlay.value = false;
}
function getInvoiceDetails(id) {
  request
    .getTitleDtatils(id)
    .then((res) => {
      let dataInfo = res.data;
      checked.value = dataInfo.title_type == "personal" ? "1" : "2";
      invoiceType.value = dataInfo.invoice_type == "plain" ? "0" : "1";
      titleValue.value = dataInfo.title;
      companyCode.value = dataInfo.tax_registration_number;
      bankName.value = dataInfo.bank_name;
      bankAccountNumber.value = dataInfo.bank_account_number;
      registrationAddress.value = dataInfo.registration_address;
      registrationPhone.value = dataInfo.registration_phone;
    })
  
}
function invoiceTypeLisen(name) {
  if (name == 0) {
    isError.value = false;
  }
}
function isSpecialEmpty() {
  return (
    titleValue.value == "" ||
    companyCode.value == "" ||
    bankName.value == "" ||
    bankAccountNumber.value == "" ||
    registrationAddress.value == "" ||
    registrationPhone.value == ""
  );
}
//保存
function apiPostCreateTitle() {
  //special invoice  value   judge  null
  isError.value = isSpecialEmpty();
  if (checked.value == 1 && titleValue.value == "") {
    return;
  }
  if (
    checked.value == 2 &&
    (titleValue.value == "" || companyCode.value == "")
  ) {
    return;
  }

  if (invoiceType.value == 1 && isError.value) {
    return;
  }
//if title type is personal,clear other table data
  if(checked.value == 1){
    clearCompanyData()
  }

  let params = {};
  params["title_type"] = checked.value == "1" ? "personal" : "company";
  params["invoice_type"] = invoiceType.value == "0" ? "plain" : "special";
  params["title"] = titleValue.value;
  params["tax_registration_number"] = companyCode.value;
  params["bank_name"] = bankName.value;
  params["bank_account_number"] = bankAccountNumber.value;
  params["registration_address"] = registrationAddress.value;
  params["registration_phone"] = registrationPhone.value;
  if (paramsId != undefined) {
    request.updateTitle(paramsId, params).then(() => {
      Toast("修改成功!");
      router.back();
    });
  } else {
    request.createUserTitle(params).then(() => {
      Toast("添加成功!");
      router.back();
    });
  }
}
function toRecharge() {
  router.push("/user/recharge");
}
</script>

<style scoped lang="scss">
.topup-close {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 22px;
  height: 22px;
}
.t-f16-c1a {
  font-size: 16px;
  color: #1a1a1a;
  font-weight: bold;
}
.tip-container {
  display: flex;
  margin-top: 20px;
  flex-direction: column;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 100%;
  margin: auto 20px;
  padding: 10px 15px;
  position: relative;
  border-radius: 5px;
  background-color: #fff;
}

.container {
  position: relative;
  height: auto;
}
.item-container {
  background: #fff;
  line-height: 44px;
  height: 44px;
  align-items: center;
  padding: 0px 15px;
}
.line {
  margin-top: 1px;
}
.question {
  width: 15px;
  height: 15px;
  margin: auto;
  margin-left: 2px;
}
::v-deep.van-radio__label {
  font-size: 14px;
  color: #1a1a1a;
}
::v-deep.van-overlay {
  z-index: 999;
}
</style>